import { render, staticRenderFns } from "./Remuneration.vue?vue&type=template&id=31070818&scoped=true"
import script from "./Remuneration.vue?vue&type=script&lang=js"
export * from "./Remuneration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31070818",
  null
  
)

export default component.exports